module.exports = __webpack_public_path__ + "img/AI-WRITER-02-m.47a34c67.png";